import { City, GameMode } from '../types';
import { COUNTRY_TO_CONTINENT } from './countryContinents';
import { isRegionalMode } from './modes';

/**
 * Annotates each city with its continent, if available.
 */
export function withContinents(cities: City[]): City[] {
  return cities.map((city) => ({
    ...city,
    continent: COUNTRY_TO_CONTINENT[city.country],
  }));
}

export function getCityPoolForMode(cities: City[], mode: GameMode): City[] {
  if (mode === 'top-100') {
    return [...cities].sort((a, b) => b.population - a.population).slice(0, 100);
  }
  if (!isRegionalMode(mode)) return cities;
  if (mode === 'india') {
    return cities.filter((city) => city.country === 'India');
  }
  if (mode === 'china') {
    return cities.filter((city) => city.country === 'China');
  }
  if (mode === 'asia-ex-india-china') {
    return cities.filter((city) => city.continent === 'asia' && city.country !== 'India' && city.country !== 'China');
  }
  return cities.filter((city) => city.continent === mode);
}
